import React, { useState } from 'react';
import { PlusIcon, TrashIcon, CalendarIcon, InfoIcon, TruckIcon, CircleDollarSignIcon } from 'lucide-react';
export function ShippingTermsStep({
  initialData,
  onUpdate
}) {
  const [formData, setFormData] = useState({
    currency: initialData.currency || 'USD',
    incoterm: initialData.incoterm || 'FOB',
    paymentTerms: initialData.paymentTerms || '30/70',
    quoteValidUntil: initialData.quoteValidUntil || '',
    desiredDeliveryDate: initialData.desiredDeliveryDate || '',
    notes: initialData.notes || '',
    shipments: initialData.shipments || [{
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }],
    ...initialData
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    onUpdate({
      ...formData,
      [name]: value
    });
  };
  const handleAddShipment = () => {
    const newShipments = [...formData.shipments, {
      origin: 'Spain',
      destination: '',
      method: 'Ocean',
      containerType: '40ft HC',
      totalPrice: 0,
      transitTime: ''
    }];
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleRemoveShipment = index => {
    const newShipments = formData.shipments.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  const handleShipmentChange = (index, field, value) => {
    const newShipments = [...formData.shipments];
    newShipments[index][field] = value;
    setFormData({
      ...formData,
      shipments: newShipments
    });
    onUpdate({
      ...formData,
      shipments: newShipments
    });
  };
  return <div className="space-y-8" data-id="element-5076">
      <div className="text-white text-xl font-medium mb-6" data-id="element-5077">
        Shipping & Payment Terms
      </div>
      {/* Financial Terms */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5078">
        <div className="flex items-center mb-4" data-id="element-5079">
          <CircleDollarSignIcon size={20} className="text-blue-400 mr-2" data-id="element-5080" />
          <h3 className="text-white font-medium" data-id="element-5081">Financial Terms</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5082">
          <div data-id="element-5083">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5084">Currency</label>
            <select name="currency" value={formData.currency} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5085">
              <option value="USD" data-id="element-5086">USD ($)</option>
              <option value="EUR" data-id="element-5087">EUR (€)</option>
              <option value="GBP" data-id="element-5088">GBP (£)</option>
              <option value="AUD" data-id="element-5089">AUD (A$)</option>
              <option value="CAD" data-id="element-5090">CAD (C$)</option>
            </select>
          </div>
          <div data-id="element-5091">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5092">Incoterm</label>
            <select name="incoterm" value={formData.incoterm} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5093">
              <option value="EXW" data-id="element-5094">EXW (Ex Works)</option>
              <option value="FCA" data-id="element-5095">FCA (Free Carrier)</option>
              <option value="FOB" data-id="element-5096">FOB (Free On Board)</option>
              <option value="CFR" data-id="element-5097">CFR (Cost and Freight)</option>
              <option value="CIF" data-id="element-5098">CIF (Cost, Insurance & Freight)</option>
              <option value="DAP" data-id="element-5099">DAP (Delivered At Place)</option>
              <option value="DDP" data-id="element-5100">DDP (Delivered Duty Paid)</option>
            </select>
          </div>
          <div data-id="element-5101">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5102">
              Payment Terms
            </label>
            <select name="paymentTerms" value={formData.paymentTerms} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
            backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right 10px center',
            backgroundSize: '20px'
          }} data-id="element-5103">
              <option value="100" data-id="element-5104">100% Payment in Advance</option>
              <option value="30/70" data-id="element-5105">30% Advance, 70% Before Shipment</option>
              <option value="50/50" data-id="element-5106">50% Advance, 50% Before Shipment</option>
              <option value="20/80" data-id="element-5107">20% Advance, 80% Before Shipment</option>
              <option value="LC" data-id="element-5108">Letter of Credit</option>
              <option value="NET30" data-id="element-5109">Net 30 Days</option>
            </select>
          </div>
        </div>
      </div>
      {/* Dates */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5110">
        <div className="flex items-center mb-4" data-id="element-5111">
          <CalendarIcon size={20} className="text-blue-400 mr-2" data-id="element-5112" />
          <h3 className="text-white font-medium" data-id="element-5113">Important Dates</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-5114">
          <div data-id="element-5115">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5116">
              Quote Valid Until
            </label>
            <div className="relative" data-id="element-5117">
              <input type="date" name="quoteValidUntil" value={formData.quoteValidUntil} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-5118" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-5119" />
            </div>
          </div>
          <div data-id="element-5120">
            <label className="block text-sm text-blue-300 mb-1" data-id="element-5121">
              Desired Delivery Date
            </label>
            <div className="relative" data-id="element-5122">
              <input type="date" name="desiredDeliveryDate" value={formData.desiredDeliveryDate} onChange={handleChange} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-5123" />
              <CalendarIcon size={18} className="absolute right-3 top-3 text-blue-400 pointer-events-none" data-id="element-5124" />
            </div>
          </div>
        </div>
      </div>
      {/* Shipments */}
      <div data-id="element-5125">
        <div className="flex items-center justify-between mb-4" data-id="element-5126">
          <div className="flex items-center" data-id="element-5127">
            <TruckIcon size={20} className="text-blue-400 mr-2" data-id="element-5128" />
            <h3 className="text-white font-medium" data-id="element-5129">Shipment Details</h3>
          </div>
          <button onClick={handleAddShipment} className="text-sm flex items-center text-blue-400 hover:text-blue-300" data-id="element-5130">
            <PlusIcon size={16} className="mr-1" data-id="element-5131" />
            Add Shipment
          </button>
        </div>
        {formData.shipments.map((shipment, index) => <div key={index} className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30 mb-4 relative" data-id="element-5132">
            {formData.shipments.length > 1 && <button onClick={() => handleRemoveShipment(index)} className="absolute top-4 right-4 p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-5133">
                <TrashIcon size={16} data-id="element-5134" />
              </button>}
            <h4 className="text-white font-medium mb-4" data-id="element-5135">
              Shipment {index + 1}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-5136">
              <div data-id="element-5137">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5138">
                  Origin
                </label>
                <input type="text" value={shipment.origin} onChange={e => handleShipmentChange(index, 'origin', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of origin" data-id="element-5139" />
              </div>
              <div data-id="element-5140">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5141">
                  Destination
                </label>
                <input type="text" value={shipment.destination} onChange={e => handleShipmentChange(index, 'destination', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Country of destination" data-id="element-5142" />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-5143">
              <div data-id="element-5144">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5145">
                  Shipping Method
                </label>
                <select value={shipment.method} onChange={e => handleShipmentChange(index, 'method', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-5146">
                  <option value="Ocean" data-id="element-5147">Ocean Freight</option>
                  <option value="Air" data-id="element-5148">Air Freight</option>
                  <option value="Road" data-id="element-5149">Road Transport</option>
                  <option value="Rail" data-id="element-5150">Rail Transport</option>
                  <option value="Multimodal" data-id="element-5151">Multimodal</option>
                </select>
              </div>
              <div data-id="element-5152">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5153">
                  Container Type
                </label>
                <select value={shipment.containerType} onChange={e => handleShipmentChange(index, 'containerType', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%238BABBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E\")",
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 10px center',
              backgroundSize: '20px'
            }} data-id="element-5154">
                  <option value="20ft" data-id="element-5155">20ft Standard</option>
                  <option value="40ft" data-id="element-5156">40ft Standard</option>
                  <option value="40ft HC" data-id="element-5157">40ft High Cube</option>
                  <option value="LCL" data-id="element-5158">LCL (Less than Container Load)</option>
                  <option value="Bulk" data-id="element-5159">Bulk Cargo</option>
                  <option value="Pallet" data-id="element-5160">Palletized</option>
                </select>
              </div>
              <div data-id="element-5161">
                <label className="block text-sm text-blue-300 mb-1" data-id="element-5162">
                  Shipping Price
                </label>
                <div className="relative" data-id="element-5163">
                  <span className="absolute left-4 top-2.5 text-gray-400" data-id="element-5164">
                    {formData.currency === 'USD' ? '$' : formData.currency === 'EUR' ? '€' : formData.currency === 'GBP' ? '£' : formData.currency === 'AUD' ? 'A$' : 'C$'}
                  </span>
                  <input type="number" value={shipment.totalPrice} onChange={e => handleShipmentChange(index, 'totalPrice', parseFloat(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-8 pr-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-5165" />
                </div>
              </div>
            </div>
            <div className="mt-4" data-id="element-5166">
              <label className="block text-sm text-blue-300 mb-1" data-id="element-5167">
                Estimated Transit Time
              </label>
              <input type="text" value={shipment.transitTime} onChange={e => handleShipmentChange(index, 'transitTime', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="E.g. 4-6 weeks" data-id="element-5168" />
            </div>
          </div>)}
      </div>
      {/* Additional Notes */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-5169">
        <div className="flex items-center mb-4" data-id="element-5170">
          <InfoIcon size={20} className="text-blue-400 mr-2" data-id="element-5171" />
          <h3 className="text-white font-medium" data-id="element-5172">Additional Notes</h3>
        </div>
        <div data-id="element-5173">
          <textarea name="notes" value={formData.notes} onChange={handleChange} rows={4} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Enter any additional notes, special requirements or terms..." data-id="element-5174"></textarea>
        </div>
      </div>
    </div>;
}